<div 
    class="task-container-mobile" 
    mat-elevation-z2 
    [formGroup]="taskFormGroup"
    [ngClass]="{'deleteModal': action == 'delete' }"
    fxShow fxHide.gt-xs
>
    <div class="task-col">
        <p>{{ "Task" | translate}} {{ getTaskNumber() + ": " }} {{ taskName }}</p>
        <p class="due-date">{{ "Due" | translate }}{{": " }}{{taskDueDate | date:'mediumDate'}}</p>
    </div>
    <button 
    *ngIf="action != 'delete'"
        mat-icon-button aria-label="Delete task button" 
        class="delete-btn" 
        (click)="onDeleteTask()"
    >
        <mat-icon>delete_outline</mat-icon>
    </button>
</div>

<div 
    class="task-container" 
    mat-elevation-z2 
    [formGroup]="taskFormGroup"
    [ngClass]="{'deleteModal': action == 'delete' }"
    fxHide fxShow.gt-xs
>
    <p>{{ "Task" | translate}} {{ getTaskNumber() + ": " }} {{ taskName }}</p>
    <p>{{ "Due" | translate }}{{": " }}{{taskDueDate | date:'mediumDate'}}</p>
    <button 
    *ngIf="action != 'delete'"
        mat-icon-button aria-label="Delete task button" 
        class="delete-btn" 
        (click)="onDeleteTask()"
    >
        <mat-icon>delete_outline</mat-icon>
    </button>
</div>